<template>
  <section class="address">
    <Header class="address__header">
      <template v-slot:title>Контроль доступа</template>
    </Header>
    <BackButton router-page-name="Gates" class="address__back">
      Назад к адресам
    </BackButton>
    <Header class="address__subheader" type="h3" spaced>
      <template v-slot:title>{{ address.address }}</template>
      <template v-slot:addons v-if="address && address.ip">
        <div class="address__addons">
          <icon-base icon-name="server" :label="address.ip" />
          <Chips v-if="chips.length" :chips="chips" />
          <span v-if="checkedAt" class="address__checked-at">
            Проверено: {{ checkedAt }}
          </span>
        </div>
      </template>
    </Header>
    <div class="address__tabs">
      <Tabs v-model="activeTab" :tabs="tabs" />
    </div>
    <div class="address__content">
      <component :is="activeTab" />
    </div>
  </section>
</template>

<script>
import Header from '../../components/Header.vue'
import Tabs from '../../components/Tabs.vue'
import Chips from '../../components/Chips.vue'
import IconBase from '../../components/Icons/IconBase.vue'
import BackButton from '../../components/BackButton.vue'
import SubscribersList from './SubscribersList.vue'
import BlePassList from './BlePassList.vue'
import ServiceData from 'Mixins/ServiceData.js'

export default {
  name: 'AddressList',
  mixins: [ServiceData],
  components: {
    Header,
    Tabs,
    Chips,
    IconBase,
    BackButton,
    SubscribersList,
    BlePassList,
  },
  data() {
    return {
      activeTab: 'subscribersList',
    }
  },
  computed: {
    currentId() {
      return this.$route.params.gateId
    },
    currentOrganizationId() {
      return this.$store.getters.currentOrganizationId
    },
    currentAddress() {
      return this.$store.getters['currentAddress']
    },
    currentServer() {
      return this.$store.getters['currentServer']
    },
    address() {
      return {
        address: this.currentAddress,
        ip: this.currentServer ? this.currentServer.host : null,
      }
    },
    serverHealth() {
      if (!this.currentServer) return null
      return this.serverHealthChecks[this.currentServer.suid] || null
    },
    chips() {
      const h = this.serverHealth
      if (!h) return []
      return [
        h.is_online
          ? {
              id: 'srvrwrks',
              type: 'complited',
              icon: 'check',
              label: 'Сервер работает',
            }
          : {
              id: 'srvrerr',
              type: 'failed',
              icon: 'cross',
              label: 'Сервер не работает',
            },
      ]
    },
    checkedAt() {
      const h = this.serverHealth
      return h?.last_health_check_at
        ? this.$moment(h.last_health_check_at).format('DD.MM.YYYY HH:mm')
        : null
    },
    contactListTotal() {
      return this.$store.getters['contactsMeta'].total
    },
    blePassListTotal() {
      return this.$store.getters['blePassesMeta'].total
    },
    tabs() {
      return [
        {
          id: 'subscribersList',
          label: 'Пользователи',
          count: this.contactListTotal,
        },
        {
          id: 'BlePassList',
          label: 'BLE пропуска',
          count: this.blePassListTotal,
        },
      ]
    },
  },
  async created() {
    this.$store.dispatch('setIsLoading', true)
    try {
      const gateResponse = await this.gateService.getGate(this.currentId)
      if (gateResponse.data) {
        this.$store.dispatch('setCurrentGate', gateResponse.data)
      }

      if (this.currentServer?.suid) {
        this.getServerHealthCheck(this.currentServer.suid)
      }

      const promises = [
        this.getBlePasses(this.currentId, {
          organization_id: this.currentOrganizationId,
          page: 1,
          per_page: 10,
        }),
      ]
      await Promise.all(promises)
    } catch (error) {
      console.error('Error loading address data:', error)
    } finally {
      this.$store.dispatch('setIsLoading', false)
    }
  },
}
</script>

<style lang="scss" scoped>
.address {
  width: 100%;

  &__header {
    margin: 0px $space-md $space-xxl;
  }

  &__back {
    margin: 0px $space-md $space-xxs;
  }

  &__subheader {
    margin: 0px $space-md $space-xl;
  }

  &__tabs {
    margin: 0px $space-md $space-lg;
  }

  &__content {
    margin: 0px;
  }

  &__addons {
    display: flex;
    align-items: center;
    gap: $space-xxs;
  }

  &__checked-at {
    font-size: 14px;
    line-height: 20px;
    color: $color-grey;
  }
}
</style>
